import { RouteConfig } from 'vue-router'

const Running = () => import('../views/ai-sports/Running.vue')

export const runningRoute: RouteConfig = {
  path: 'ai-sports',
  name: 'ai_sports',
  component: Running,
  props: (route: any) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI运动',
  },
}

export default [runningRoute]
